import type { FC } from "react";
import React from "react";

import { Tag } from "../../../../Tag";

import type {
    PropsWithCustomColorsStyles,
    OmitOfUnion,
} from "../../../../../types/react";
import type { TagProps } from "../../../../Tag/Tag/Tag";

const AVATAR_TAG_TEST_ID = "avatar-tag-test-id";

type AvatarSizeTagProps = "size";

type ExtendedTagProps = TagProps;

type AvatarTagProps = OmitOfUnion<ExtendedTagProps, AvatarSizeTagProps> &
    Partial<PropsWithCustomColorsStyles>;

export const AvatarTag: FC<AvatarTagProps> = (props) => {
    const { ...restProps } = props;

    return <Tag {...(restProps as TagProps)} data-tsid={AVATAR_TAG_TEST_ID} />;
};

AvatarTag.displayName = "Avatar.Tag";

export default AvatarTag;
